import Module from '../module';
import scroll from '../../libs/scroll/scroll';

interface OptionsInterface {
	cssId: {
		anim?: {
			contactDataContentSectionCls: string;
		}
	},

	slug: string
}

class Data extends Module {

	publicVars: OptionsInterface;

	constructor(options: OptionsInterface) {
		super('Contact Data Module');

		this.publicVars = options;
	}

	startup() {
		this.msg('startup');

		scroll.init();
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.contactDataContentSectionCls || '', 'contact_data', { animCls: 'animate__fadeIn', once: true});
	}

	bind() {
		this.msg('bind');
	}
}

export default Data;